// we want to track the visibility of all items with this class
const items = document.querySelectorAll('.contact-button');
const elementToToggle = document.getElementById('contact-footer');
let visibilities = [];

const observer = new IntersectionObserver(entries => {
  entries.forEach(function(entry) {
    let hideElement = false;

    visibilities[entry.target.id] = entry.isIntersecting;
    for (let tracked_element in visibilities){
      hideElement ||= visibilities[tracked_element];
    }
    elementToToggle.style.display = hideElement ? 'none': 'block';

  });
});

items.forEach(element => {
  observer.observe(element);
});


(function($, Drupal) {

  'use strict';

  $('button.show-contacts-button')
    .click(function () {
      $(this).fadeOut(200, function () {
        $('div.contact-information-block').fadeIn(100);
      });

    });
})(jQuery, Drupal);
